import { useEffect, useState } from "react";
import { BaseUploadNodeProps } from "imagica-uikit/dist/nodesV2/typing";
import { DisplayType } from "../typing";
import { Api } from "@uikit/service/api";
import isBlank from "@sedan-utils/is-blank";

export function useCreateBlobUrl(
  url: string | undefined,
  unStructuredDownloadFailedText: string | undefined,
  initCreateBlobUrl: BaseUploadNodeProps["createBlobUrl"],
  displayType: DisplayType
) {
  const api = new Api(false);

  const [objectURL, setObjectURL] = useState<string | undefined>();
  const [fileBlob, setFileBlob] = useState<Blob | undefined>();
  const [loading, setLoading] = useState<boolean | undefined>();

  const downloadMetaData = async (url: string) => {
    try {
      setLoading(true);
      // handle old urls with duplicated api root
      const { fileUrl, blob } = await api.getByCustomType(url);

      setObjectURL(fileUrl);
      setFileBlob(blob);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  const setCreateBlobUrl = async () => {
    if (initCreateBlobUrl) {
      setObjectURL(initCreateBlobUrl?.objectURL);
      setFileBlob(initCreateBlobUrl?.fileBlob);
      setLoading(initCreateBlobUrl?.loading);
      if (initCreateBlobUrl?.objectURL && isBlank(initCreateBlobUrl?.fileBlob)) {
        const blob = await fetch(initCreateBlobUrl?.objectURL).then(res => res.blob());
        setFileBlob(blob);
      }
    }
  };

  useEffect(() => {
    if (displayType === "uploadFile") {
      return;
    }
    if (initCreateBlobUrl) {
      setCreateBlobUrl();
      return;
    }
    if (url) {
      downloadMetaData(url);
    }
  }, [url, initCreateBlobUrl, displayType]);

  return url
    ? {
        objectURL,
        fileBlob,
        loading,
        unStructuredDownloadFailedText: loading === false ? unStructuredDownloadFailedText : undefined,
      }
    : undefined;
}
